import React from 'react';
import {
  BlockLeftLayout,
  BlockRightLayout,
  CardInformationSalesReportWrapper
} from './CardInformationSalesReport.style';
import Logo from '../../../../../../../assets/Logo/Logo.png';

const CardInformationSalesReport = ({
  invoiceNumber,
  mainName,
  address,
  vatNumber,
  typeOfInvoice,
  startAt,
  endAt
}: any) => {
  return (
    <CardInformationSalesReportWrapper>
      <BlockLeftLayout>
        <div className="mainName">{mainName}</div>
        <div className="inforWrapper">
          <div className="address">{address}</div>
        </div>
        <div className="vatWrapper">
          <div className="vatLabel">
            <div className="vatNumber">Numéro de TVA</div>
          </div>
          <div className="vatLabel">
            <div className="vatNumber">{vatNumber}</div>
          </div>
        </div>
        <div className="leftBottomWapper">
          <div className="leftBottom">
            <div className="labelBottom">Numéro de Facture</div>
            <div className="labelBottom">Date de la facture</div>
            <div className="labelBottom">Type de facture</div>
            <div className="labelBottom">Période facturée</div>
            <div className="labelBottom">Prochain paiement</div>
          </div>
          <div className="leftBottom">
            <div className="valueBottom">{invoiceNumber}</div>
            <div className="valueBottom">{startAt}</div>
            <div className="valueBottom">{typeOfInvoice}</div>
            <div className="valueBottom">
              {startAt} - {endAt}
            </div>
            <div className="valueBottom">{endAt}</div>
          </div>
        </div>
      </BlockLeftLayout>
      <BlockRightLayout>
        <img src={Logo} alt="" />
      </BlockRightLayout>
    </CardInformationSalesReportWrapper>
  );
};

export default CardInformationSalesReport;
